import React from 'react';
import { Button } from './ui/Button';
import { Star, ShieldCheck } from 'lucide-react';
export function Hero() {
  return <div className="relative overflow-hidden bg-[#FFFDF5] pt-12 pb-20 lg:pt-20 lg:pb-28" data-id="element-83">
      {/* Decorative blobs */}
      <div className="absolute top-0 right-0 -mr-20 -mt-20 w-96 h-96 bg-[#F5C842] opacity-10 rounded-full blur-3xl" data-id="element-84"></div>
      <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-80 h-80 bg-[#4AAAA5] opacity-10 rounded-full blur-3xl" data-id="element-85"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-86">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-87">
          <div className="text-center lg:text-left space-y-8" data-id="element-88">
            <div className="inline-flex items-center px-4 py-2 rounded-full bg-[#E6F4F4] text-[#4AAAA5] font-medium text-sm mb-4" data-id="element-89">
              <Star className="w-4 h-4 mr-2 fill-current" data-id="element-90" />
              Más de 1,000 familias felices
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight tracking-tight text-center" data-id="element-91">
              El berrinche de la mañana empieza cuando{' '}
              <span className="text-red-600 font-bold underline decoration-red-600 decoration-4 underline-offset-8" data-id="element-92">
                no hay un sistema
              </span>
            </h1>

            <p className="text-xl text-gray-600 leading-relaxed max-w-2xl mx-auto lg:mx-0" data-id="element-93">
              Si tus mañanas son una carrera contra el reloj y cada paso termina
              en discusión, no estás fallando. Solo te falta el mapa correcto.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4" data-id="element-94">
              <Button size="lg" withIcon href="https://www.mundomamis.com/cart/43938138390637:1" data-id="element-95">
                Quiero el Kit - $6.39 USD
              </Button>
              <p className="text-sm text-gray-500 flex items-center" data-id="element-96">
                <ShieldCheck className="w-4 h-4 mr-1 text-[#4AAAA5]" data-id="element-97" />
                Descarga inmediata
              </p>
            </div>
          </div>

          <div className="relative mx-auto w-full max-w-md lg:max-w-full" data-id="element-98">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl transform rotate-2 hover:rotate-0 transition-transform duration-500 border-8 border-white" data-id="element-99">
              <img src="https://cdn.magicpatterns.com/uploads/csN58Nbj9T719GyQZvkfKA/kit.png" alt="Kit de Rutinas Visuales Anti-Berrinches" className="w-full h-auto object-cover" data-id="element-100" />
            </div>
            {/* Floating badge */}
            <div className="absolute -bottom-6 -right-6 bg-[#F5C842] text-gray-900 font-bold p-4 rounded-full shadow-lg transform rotate-12 flex flex-col items-center justify-center w-24 h-24 border-4 border-white" data-id="element-101">
              <span className="text-xs uppercase tracking-wide" data-id="element-102">Solo</span>
              <span className="text-2xl" data-id="element-103">$6.39</span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}